import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/pagination';
import CancelOrderModal from './cancelordermodal';

import {
  fetchOpenOrders,
  deleteOrder,
  fetchBalance,
} from '../../actions';

const dateFormat = 'L LT';

class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersPerPage: 10,
      currentPage: 1,
      currentPair: '',
      deleteMode: false,
      sortType: 'createdAt',
      sortReverse: false,
    };
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.resize = this.resize.bind(this);
    this.orderDelete = this.orderDelete.bind(this);
    this.sortOrders = this.sortOrders.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    if (window.innerWidth > 720 && !this.state.deleteMode) {
      this.setState({
        deleteMode: true,
      });
    }

    if (this.props.orders.length) {
      return;
    }

    // const { dispatch, pair } = this.props;
    // const data = {
    //   pair,
    //   status: 'OPEN',
    //   queued: true,
    // };
    // dispatch(fetchOpenOrders(data));
    // this.setState({ currentPair: pair });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
    }
  }

  resize() {
    if (window.innerWidth > 720 && !this.state.deleteMode) {
      this.setState({
        deleteMode: true,
      });
    }
  }

  orderDelete(id) {
    const { dispatch, pair } = this.props;
    const data = {
      pair,
      status: 'OPEN',
      queued: true,
      self: true,
    };

    dispatch(deleteOrder(id))
      .then((res) => {
        if (res.type === 'DELETE_ORDER_SUCCESS') {
          dispatch(fetchOpenOrders(data));
          dispatch(fetchBalance({}));
        }
      });
  }

  sortOrders(param) {
    const { sortType, sortReverse } = this.state;
    if (param === sortType) {
      this.setState({
        sortReverse: !sortReverse,
      });
    } else {
      this.setState({
        sortType: param,
        sortReverse: false,
      });
    }
  }

  render() {
    const { orders, exchA, exchB, isOfType } = this.props;
    const { ordersPerPage, currentPage, deleteMode, sortType, sortReverse } = this.state;

    let indexOfLastOrder;
    let indexOfFirstOrder;
    let currentOrders;
    let ordersLength;
    let sortedOrders;

    if (orders && orders.open) {
      // if sort type is a number, sort as number
      if (sortType === 'quantity' || sortType === 'value') {
        if (sortReverse) {
          // ascending
          sortedOrders = orders.open.sort(function(a, b) {
            if (Number(a[sortType]) > Number(b[sortType]))
              return 1;
            if (Number(a[sortType]) < Number(b[sortType]))
              return -1;
            return 0;
          });
        } else {
          // descending
          sortedOrders = orders.open.sort(function(a, b) {
            if (Number(a[sortType]) > Number(b[sortType]))
              return -1;
            if (Number(a[sortType]) < Number(b[sortType]))
              return 1;
            return 0;
          });
        }
      } else {
        // sort as string
        if (sortReverse) {
          // ascending
          sortedOrders = orders.open.sort(function(a, b) {
            if (a[sortType] > b[sortType])
              return 1;
            if (a[sortType] < b[sortType])
              return -1;
            return 0;
          });
        } else {
          // descending
          sortedOrders = orders.open.sort(function(a, b) {
            if (a[sortType] > b[sortType])
              return -1;
            if (a[sortType] < b[sortType])
              return 1;
            return 0;
          });
        }
      }

      indexOfLastOrder = currentPage * ordersPerPage;
      indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);
      ordersLength = sortedOrders.length;
    }

    const tableLoop = currentOrders && currentOrders.map((order, index) => {
      return (
        // <tr key={index} className={order.status === 'QUEUED' ? 'order-queued' : ''}>
        <tr key={index}>
          <td>{moment.unix(order.createdAt).format(dateFormat)}</td>
          <td>{order.value}</td>
          <td>{order.quantity}</td>
          <td>{order.type}</td>
          { deleteMode && (
            <td>
              <FontAwesomeIcon
                style={{
                  color: 'rgb(255, 99, 51)',
                }}
                size="lg"
                icon={faTimes}
                className={'del-icon'}
                onClick={() => this.orderDelete(order.referenceId)}
              />
            </td>
          )}
        </tr>
      );
    });

    return (
      <div className="cell panel">
        <div className="panel-label gl-button">
          <span>Open Orders</span>
        </div>
        {currentOrders && currentOrders.length ? (
          <div>
            <table>
              <thead>
                <tr>
                  <th
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.sortOrders('createdAt')}
                    className="table-sort"
                  >
                    Created At
                    { sortType === 'createdAt' ? (
                      <FontAwesomeIcon
                        icon={sortReverse ? faChevronUp : faChevronDown}
                      />
                    ) : (
                      null
                    )}
                  </th>
                  <th
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.sortOrders('value')}
                    className="table-sort"
                  >
                    Price ({exchB})
                    { sortType === 'value' ? (
                      <FontAwesomeIcon
                        icon={sortReverse ? faChevronUp : faChevronDown}
                      />
                    ) : (
                      null
                    )}
                  </th>
                  <th
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.sortOrders('quantity')}
                    className="table-sort"
                  >
                    Volume Remaining {isOfType(exchA, 'METAL') && '(grams)'}
                    { sortType === 'quantity' ? (
                      <FontAwesomeIcon
                        icon={sortReverse ? faChevronUp : faChevronDown}
                      />
                    ) : (
                      null
                    )}
                  </th>
                  <th
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.sortOrders('type')}                    className="table-sort"
                  >
                    Order Type
                    { sortType === 'type' ? (
                      <FontAwesomeIcon
                        icon={sortReverse ? faChevronUp : faChevronDown}
                      />
                    ) : (
                      null
                    )}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tableLoop}
              </tbody>
            </table>
            <Pagination
              rowsPerPage={ordersPerPage}
              totalRows={ordersLength}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
            <div className="mobile-del-btn">
              <button type="button" className="vlt-button dark-b" onClick={() => this.props.toggleModal(<CancelOrderModal toggleModal={this.props.toggleModal} modalComponent={this.state.modalComponent} exchA={exchA} exchB={exchB} orderDelete={this.orderDelete} />)}>Edit Orders</button>
            </div>
          </div>
        ) : (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Created At</th>
                  <th>Price ({exchB})</th>
                  <th>Volume Remaining {isOfType(exchA, 'METAL') && '(grams)'}</th>
                  <th>Order Type</th>
                  <th></th>
                </tr>
              </thead>
            </table>
            <h3 className="no-data">No Open Orders</h3>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
});

export default connect(mapStateToProps)(MyOrders);
